import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    FETCH_FILTER_CONTACTS,
    FETCH_FILTER_CONTACTS_FAILURE,
    FETCH_FILTER_CONTACTS_SUCCESS,
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
    INITIALIZE_REASIGN_FORM,
    RESET,
    RESET_REASIGN_FORM,
    SAVE_CONTACT,
    SAVE_CONTACT_FAILURE,
    SAVE_CONTACT_SUCCESS,
    SET_IS_DOWNLOADING,
    SET_IS_OPEN_REASIGN_MODAL,
    SET_IS_UPLOADING,
    SHOW_EMPTY_STATE,
    UPDATE_ITEMS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    users: {
        data: [],
        error: null,
        isEmpty: false,
        isLoading: false,
    },
    bulkUpdateItems: {
        data: [],
        errors: [],
        isFetching: false,
    },
    contacts: {
        data: {
            data: [],
            pagination: null,
        },
        errors: [],
        isFetching: false,
    },
    isDownloading: false,
    isInitializing: false,
    isOpenReasignModal: false,
    isUploading: false,
    reasignInitialValues: {
        callback: null,
        contacts: [],
        user: null,
    },
    saveContact: {
        data: {},
        errors: [],
        isSaving: false,
    },
    showEmptyState: {
        status: 'active',
        show: false,
    },
};

const contactSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isFetching: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USERS]: (state) => {
            state.users.isLoading = true;
        },
        [FETCH_USERS_FAILURE]: (state, action) => {
            state.users = {
                ...state.users,
                error: action.payload,
                isLoading: false,
            };
        },
        [FETCH_USERS_SUCCESS]: (state, action) => {
            state.users = {
                ...state.users,
                data: action.payload,
                isLoading: false,
            };
        },
        [FETCH_FILTER_CONTACTS]: (state) => {
            state.contacts = {
                ...state.contacts,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_FILTER_CONTACTS_FAILURE]: (state, action) => {
            state.contacts = {
                ...state.contacts,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_FILTER_CONTACTS_SUCCESS]: (state, action) => {
            state.contacts = {
                ...state.contacts,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE]: (state) => {
            state.isInitializing = true;
        },
        [INITIALIZE_FAILURE]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_SUCCESS]: (state) => {
            state.isInitializing = false;
        },
        [INITIALIZE_REASIGN_FORM]: (state, action) => {
            state.reasignInitialValues = {
                ...state.reasignInitialValues,
                ...action.payload,
            };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_REASIGN_FORM]: (state) => {
            state.reasignInitialValues = INITIAL_STATE.reasignInitialValues;
        },
        [SAVE_CONTACT]: (state) => {
            state.saveContact = {
                ...state.saveContact,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_CONTACT_FAILURE]: (state, action) => {
            state.saveContact = {
                ...state.saveContact,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_CONTACT_SUCCESS]: (state, action) => {
            state.saveContact = {
                ...state.saveContact,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_DOWNLOADING]: (state, action) => {
            state.isDownloading = action.payload;
        },
        [SET_IS_OPEN_REASIGN_MODAL]: (state, action) => {
            state.isOpenReasignModal = action.payload;
        },
        [SET_IS_UPLOADING]: (state, action) => {
            state.isUploading = action.payload;
        },
        [SHOW_EMPTY_STATE]: (state, action) => {
            state.showEmptyState = action.payload;
        },
        [UPDATE_ITEMS_SUCCESS]: (state, action) => {
            state.contacts.data.data = action.payload;
        },
    },
});

export const contactActions = contactSlice.actions;

export default contactSlice.reducer;
